/* eslint-disable import/no-anonymous-default-export */
export default (adminData = {}, action) => {
    switch (action.type) {
        case "ADMIN_LOGIN":
            return { ...action.payload }
        default:
            return adminData
    }
}